import React from 'react';
import { Lightbulb, CodeSlash, FileEarmarkText } from 'react-bootstrap-icons';

const PROMPTS = [
  {
    Icon: Lightbulb,
    title: 'Explore a topic',
    prompt: 'Why do leaves turn orange in autumn?',
    tint: 'bg-brand-amber/20 text-brand-amber',
  },
  {
    Icon: CodeSlash,
    title: 'Get unstuck',
    prompt: 'My Python loop keeps printing forever and I can’t see why.',
    tint: 'bg-brand-sky/20 text-brand-sky',
  },
  {
    Icon: FileEarmarkText,
    title: 'Study your notes',
    prompt: 'Here’s my history PDF — help me get ready for the test on it.',
    tint: 'bg-brand-mint/20 text-brand-mint',
  },
];

export default function ExamplePrompts({ onSignIn }) {
  return (
    <section id="examples" className="scroll-mt-24 bg-brand-navy-50/70 py-14 sm:py-16">
      <div className="mx-auto max-w-landing px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div className="max-w-2xl">
            <p className="text-sm font-semibold uppercase tracking-wide text-brand-navy">Examples</p>
            <h2 className="mt-2 font-display text-3xl font-extrabold text-brand-ink sm:text-4xl">
              Just ask in your own words
            </h2>
            <p className="mt-3 text-brand-muted">
              No special phrasing needed — SchoolCracked meets you at your level and asks
              questions back until it clicks.
            </p>
          </div>
          <button
            type="button"
            onClick={onSignIn}
            className="shrink-0 self-start rounded-pill bg-brand-navy px-5 py-2.5 text-sm font-semibold text-white shadow-brand-sm hover:bg-brand-navy-800 sm:self-auto"
          >
            Open chat
          </button>
        </div>

        <div className="mt-10 grid gap-4 md:grid-cols-3">
          {PROMPTS.map(({ Icon, title, prompt, tint }) => (
            <button
              key={title}
              type="button"
              onClick={onSignIn}
              className="flex flex-col items-start rounded-card border border-brand-line bg-white p-5 text-left shadow-brand-sm transition hover:-translate-y-0.5 hover:border-brand-navy/30 hover:shadow-brand-md"
            >
              <span className={`inline-flex h-10 w-10 items-center justify-center rounded-xl ${tint}`}>
                <Icon size={18} />
              </span>
              <span className="mt-3 font-display text-base font-bold text-brand-ink">{title}</span>
              <span className="mt-2 text-sm leading-relaxed text-brand-muted">“{prompt}”</span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
